const config = {
	apiPrefix: '/plus-one',
	authKey: 'satoken',
	menuKey: 'MENU_LIST'
}
export default config
